'use client';

import type { FundingSavedCard } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';

export function useFundingCardLabel(card: FundingSavedCard | null | undefined): string | undefined {
  const t = useTranslations('onramp');
  if (!card) return undefined;
  const brand = card.brand.charAt(0).toUpperCase() + card.brand.slice(1);
  const label = t('saved_card_label', { brand, last4: card.last4 });
  const type =
    card.cardType === 'debit'
      ? t('card_debit')
      : card.cardType === 'credit'
        ? t('card_credit')
        : card.cardType === 'prepaid'
          ? t('card_prepaid')
          : null;
  return type ? `${label} · ${type}` : label;
}
